class NewRelicLogProvider {
    log(severity, mwcId, message, stackTrace) {
        switch (severity) {
            case 'fatal':
            case 'error':
                this.constructor.error(mwcId, message, stackTrace);
                break;
            case 'trace':
                break;
            case 'usage':
                this.constructor.usage(mwcId, message);
                break;
            default:
                break;
        }
    }

    static error(mwcId, message, stackTrace) {
        const additionalInfo = {
            mwcId,
            stackTrace,
        };
        window.newrelic.noticeError(message, additionalInfo);
    }

    static usage(mwcId, infoObject) {
        // All items in properties will become columns in new relic
        const additionalInfo = infoObject.properties || {};
        additionalInfo.action = infoObject.action;
        additionalInfo.mwcId = mwcId;

        if (additionalInfo.context) {
            // Not sure this is used still but leaving in just in case
            additionalInfo.category = additionalInfo.context.category;
        }

        if (infoObject.startTime && infoObject.endTime) {
            additionalInfo.value = {
                startTime: infoObject.startTime,
                endTime: infoObject.endTime,
                elapsedTime: infoObject.endTime - infoObject.startTime,
            };
        }

        window.newrelic.addPageAction(infoObject.action, additionalInfo);
    }
}

function setAppContext(appContext) {
    // set custom attributes for app
    ['namespace', 'environment', 'configVersion'].forEach((key) => {
        window.newrelic.setCustomAttribute(key, appContext[key] || '');
    });
    // set custom attributes for userIdentity
    if (appContext.userIdentity) {
        ['userId', 'sessionId'].forEach((key) => {
            window.newrelic.setCustomAttribute(key, appContext.userIdentity[key] || '');
        });
    }
}

export {
    NewRelicLogProvider as default,
    setAppContext,
};



// WEBPACK FOOTER //
// ../loader-base/src/services/new-relic-provider.js